module.exports = __webpack_public_path__ + "static/media/inplay.5b7fa7aa.svg";